export default __webpack_public_path__ + "static/media/Classwin logo_Classwin Horizontal - White 2.4bee6b3e.png";